import { D3Selection } from "svg/draw/draw-calendar";
import { PrintPdfFontResponse, TextInformation } from "burde";
import { Anchor, LegacyFonts } from "svg/constants";

const drawCoverText = (
    group: D3Selection,
    textInformation: TextInformation,
    index: number,
    fontOptions: PrintPdfFontResponse | null,
) => {
    let fontSetName = textInformation.fontSetName;
    let fontFamily = "";

    if (fontSetName) {
        const legacyFont = LegacyFonts.find(
            (x) => x.title === textInformation.fontSetName,
        );

        fontFamily = legacyFont ? legacyFont["font-family"] : "";
    } else {
        const font = fontOptions
            ? fontOptions.fontResources.find(
                  (x) => x.id === textInformation.fontId,
              )
            : undefined;

        fontFamily = font ? font["font-family"] : "";
    }

    group
        .append("text")
        .attr("data-index", index)
        .attr("font-size", textInformation.fontSize + "pt")
        .attr("font-family", fontFamily)
        .attr("fill", textInformation.color)
        .attr("text-anchor", Anchor.middle)
        .attr(
            "transform",
            `translate(${textInformation.x} ${textInformation.y}) rotate(${
                textInformation.rotation ? textInformation.rotation : 0
            })`,
        )
        .text(textInformation.text);
};

export { drawCoverText };
